import { keyframes } from "@emotion/css";

export const appearingAnimation = keyframes`
    0% {
        transform: scale(0.98);
        opacity: 0;
    }

    100% {
        transform: scale(1);
        opacity: 1;
    }
`;
